export default function toStringNormalize(text) {
  return text ? text.toString().toLocaleLowerCase().replace(/\b\w/g, l => l.toUpperCase()) : null;
}
